import { SagaIterator } from "redux-saga";
import { takeLatest, put, call, select } from "redux-saga/effects";
import { getGiftGroupsApi } from "../../../axios";
import { selectToken } from "../../selectors";
import * as actions from "../../actions";
import { getGiftGroupsAction } from "../../../constants";

function* getGiftGroupsSaga(): SagaIterator {
  try {
    const token = yield select(selectToken);

    const response = yield call(getGiftGroupsApi, token);
    yield put(actions.getGiftGroupsSuccess(response.data));
  } catch (e) {
    yield put(actions.getGiftGroupsFailure(e as Error));
  }
}

export function* watchGetGiftGroupsSaga(): SagaIterator {
  yield takeLatest(getGiftGroupsAction.requested, getGiftGroupsSaga);
}
